var carouselBlock = (function () {
  return {
    init: init,
  };
  function init() {
    var sliderOption = {
      selector: ".bstack-timeline-container",
      cssClass: [],
      slide: {
        1300: 1,
        980: 1,
        640: 1,
        320: 1,
      },
    };
    if (document.querySelector(".carousel-timeline-inter")) {
      sliderOption.showDots = true;
    }
    var slider = new bstackSlider(sliderOption),
      sel = document.querySelector(".bstack-timeline-container");
    if (sel != null && sliderOption.showDots) {
      var leftButton = sel.querySelector("[data-action='slideLeft']"),
        sliderDots = sel.querySelectorAll(".bstack-slider-dots-btn"),
        rightButton = sel.querySelector("[data-action='slideRight']");

      leftButton.addEventListener("click", selectYearTab);
      rightButton.addEventListener("click", selectYearTab);
    }

    function selectYearTab() {
      var currentIndex = slider.slideIndex;
      if (sliderDots[currentIndex].classList.contains("invisible")) {
        for (var i = currentIndex; 0 <= i; i--) {
          if (sliderDots[i].classList.contains("invisible") == false) {
            sliderDots[i].classList.add("active");
            break;
          }
        }
      }
    }
  }
})();

carouselBlock.init();
